@if (
  {
    row: columnData | async,
  };
  as $
) {
  <p-tag
    styleClass="mr-3 surface-200 text-800 text-xxs font-semibold uppercase white-space-nowrap border-1 border-300"
    aria-label="deposit-name-tag"
    >{{ $.row.deposit_name }}</p-tag
  >
  <span>{{ ('DEPOSIT.' + $.row.occurence_type) | depositTranslate }}</span>
}
